import each from 'lodash/each';
import sortBy from 'lodash/sortBy';
import countryRegionData from 'country-region-data';

let sortedCountries = sortBy(countryRegionData, 'name'),
  covidExcludes = [
    'DZ', 'AO', 'AG', 'AW', 'AZ', 'BS', 'BH', 'BD', 'BB', 'BZ',
    'BJ', 'BM', 'BO', 'BA', 'BW', 'BF', 'BI', 'CM', 'CV', 'KY',
    'TD', 'CO', 'CG', 'CD', 'CK', 'CR', 'CU', 'CW', 'DO', 'EC',
    'EE', 'ET', 'FO', 'FJ', 'PF', 'GM', 'GH', 'GD', 'GT', 'GW',
    'GY', 'HT', 'HN', 'IN', 'IQ', 'IL', 'JM', 'KZ', 'KE', 'KI',
    'KG', 'LA', 'LB', 'LS', 'LR', 'LY', 'MG', 'MW', 'MV', 'MR',
    'MU', 'MD', 'MN', 'ME', 'MA', 'MZ', 'NP', 'NC', 'PG', 'NI',
    'PK', 'PA', 'PG', 'PY', 'PE', 'PH', 'QA', 'RW', 'WS', 'SN',
    'SC', 'SL', 'SB', 'SS', 'SX', 'SD', 'SR', 'SZ', 'TJ', 'TZ',
    'TL', 'TO', 'TT', 'TN', 'TC', 'UG', 'UY', 'VU', 'VE', 'YE',
    'ZM', 'ZW', 'MX',
  ],
  temporaryExcludedCountries = ['RU'],
  excludedCountries = [
    'AR', 'BR', 'CL', 'EG', 'KW', 'NG', 'OM', 'ZA', 'LK', 'AE', 
    'SA', 'KH', 'HR', 'MK', 'MM', 'SK', 'PR', 'SG',
    ...covidExcludes,
    ...temporaryExcludedCountries,
  ],
  countries = {};

each(sortedCountries, country => {
  if (!excludedCountries.includes(country.countryShortCode)) {
    countries[country.countryShortCode] = country.countryName;
  }
});

export default countries;
